export default __webpack_public_path__ + "static/img/vogue_scene_animated_0751.49070fd.webp";